import React from "react"
import SEO from "../components/common/SEO"
import ServicePageHero from "../components/services/ServicePageHero.jsx"

const facilities = [
  {
    id: 1,
    title: "Piscine Intérieure Chauffée",
    image: "/images/pool.jpg",
    description:
      "Profitez d'une élégante piscine intérieure chauffée, idéale pour la détente, la relaxation et le bien-être tout au long de l'année.",
  },

  {
    id: 2,
    title: "Hammam Traditionnel",
    image: "/images/service-hammam.jpg",
    description:
      "Découvrez les bienfaits du hammam traditionnel pour purifier la peau, détendre les muscles et revitaliser le corps.",
  },

  {
    id: 3,
    title: "Salle de Remise en Forme",
    image: "/images/fitness.jpg",
    description:
      "Un espace fitness moderne équipé pour vos séances de cardio, de remise en forme et de bien-être physique.",
  },

  {
    id: 4,
    title: "Bain Hydro-Massant",
    image: "/images/gallery-2.jpg",
    description:
      "Profitez d'un bain hydro-massant relaxant favorisant la circulation sanguine et la récupération musculaire.",
  },

  {
    id: 5,
    title: "Espace Détente",
    image: "/images/gallery-6.jpg",
    description:
      "Un environnement calme et raffiné conçu pour prolonger votre expérience de relaxation après vos soins.",
  },
]

export default function WellnessFacilities() {
  return (
    <>
      <SEO
        title="Installations Bien-Être | Centre SpaLand Saphir Palace & Spa"
        description="Piscine intérieure chauffée, hammam traditionnel, salle de fitness, bain hydro-massant et espaces détente à Hammamet."
        keywords="piscine intérieure hammamet, hammam hammamet, fitness spa, bien-être hammamet"
        url="https://www.yourdomain.com/services/installations"
      />

      <main>
        {/* Hero */}
        {/*
        <section
          style={{
            padding: "120px 20px",
            textAlign: "center",
            background: "#f9f6f1",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              marginBottom: "20px",
            }}
          >
            Installations Bien-Être
          </h1>

          <p
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              color: "#666",
              lineHeight: "1.8",
            }}
          >
            Découvrez nos espaces dédiés à la détente, au sport et au bien-être
            pour compléter votre expérience spa dans un cadre élégant et apaisant.
          </p>
        </section>
*/}
<ServicePageHero
  title="Installations Bien-Être"
  description="Profitez de notre piscine intérieure chauffée, de notre hammam traditionnel et de nos espaces dédiés à la détente."
  image="/images/pool.jpg"
/>
        {/* Facilities */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1300px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(350px, 1fr))",
              gap: "35px",
            }}
          >
            {facilities.map((facility) => (
              <div
                key={facility.id}
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow:
                    "0 10px 30px rgba(0,0,0,0.08)",
                }}
              >
                <img
                  src={facility.image}
                  alt={facility.title}
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "cover",
                  }}
                />

                <div
                  style={{
                    padding: "30px",
                  }}
                >
                  <h3
                    style={{
                      marginBottom: "15px",
                    }}
                  >
                    {facility.title}
                  </h3>

                  <p
                    style={{
                      color: "#666",
                      lineHeight: "1.8",
                    }}
                  >
                    {facility.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section
          style={{
            padding: "100px 20px",
            textAlign: "center",
            background: "#111",
            color: "#fff",
          }}
        >
          <h2
            style={{
              fontSize: "2.5rem",
              marginBottom: "20px",
            }}
          >
            Vivez Une Expérience Bien-Être Complète
          </h2>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto 30px",
              color: "#ddd",
            }}
          >
            Associez nos soins spa à nos installations premium pour profiter
            d'une journée de détente et de revitalisation exceptionnelle.
          </p>

          <a
            href="https://wa.me/216XXXXXXXX"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "#b8955d",
              color: "#fff",
              padding: "14px 30px",
              borderRadius: "50px",
              textDecoration: "none",
              fontWeight: "600",
            }}
          >
            Réserver via WhatsApp
          </a>
        </section>
      </main>
    </>
  )
}